import PortalVue from 'portal-vue';

export default (Vue) => {
    Vue.use(PortalVue);
};
